<template>
	<div class="percentage-wrapper">
		<div id="percent" ref="percentage" class="percentage" ></div>

		<div class="hoofdstukken">
			<div class="hoofdstuk"
				v-for="hoofdstuk in hoofdstukken" 
				:key="hoofdstuk"
				@click='goToId(hoofdstuk.id)'>
				{{ hoofdstuk.tekst }}
			</div>
		</div>

		<div class="knd-menu-button" @click="toggleMenu()">
			<div class="knd-menu-dot"></div>
			<div class="knd-menu-dot"></div>
			<div class="knd-menu-dot"></div>
		</div>
	</div>
</template>

<script>
	import './percentage.scss';

	const vueObject = {
		data() {
			return {
				hoofdstukken: [
					{
						tekst: "1 - Caroliens weiland",
						id: "carolien1"
					},
					{
						tekst: "2 - Verdeel Nederland",
						id: "nederland"
					},
					{
						tekst: "3 - Landbouwgrond verdwijnt",
						id: "quiz"
					},
					{
						tekst: "4 - Alternatieven",
						id: "carolien2"
					},
					{
						tekst: "5 - Gevecht om de grond",
						id: "uitsmijter"
					}
				]
			}
		},
		mounted: function() {
			const percentLabel = document.querySelector("#percent");

			window.addEventListener("scroll", () => {
				let scrollTop = window.scrollY;
				let docHeight = document.body.offsetHeight;
				let winHeight = window.innerHeight;
				let scrollPercent = scrollTop / (docHeight - winHeight);
				let scrollPercentRounded = Math.round(scrollPercent * 100);

				percentLabel.style.width = scrollPercentRounded + '%';
			});			
		},
		methods: {
			goToId(name) {
				const tool = document.querySelector("#" + name);
				tool.scrollIntoView({behavior: "smooth", block: "start"});

				const hoofdstukken = document.querySelectorAll(".hoofdstukken");
				hoofdstukken[0].classList.toggle("show");
			},

			toggleMenu() {
				const hoofdstukken = document.querySelectorAll(".hoofdstukken");
				hoofdstukken[0].classList.toggle("show");

				console.log(hoofdstukken[0].classList);
			}
		}
	}

	export default vueObject;
</script>